// extracted by mini-css-extract-plugin
export default {"marquee":"style_marquee__y6Hmx","propertyStart":"style_propertyStart__uEybJ","logoWrapper":"style_logoWrapper__okFLa"};